import { render, staticRenderFns } from "./industries.vue?vue&type=template&id=160558e4"
import script from "./industries.vue?vue&type=script&lang=js"
export * from "./industries.vue?vue&type=script&lang=js"
import style0 from "./industries.vue?vue&type=style&index=0&id=160558e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports